import React from 'react';
import { Link } from 'react-router-dom';
import { observer,inject } from 'mobx-react';
import { Navbar, NavItem, Nav } from 'react-bootstrap';

@inject('userStore')
@observer
class Header extends React.Component {
  
  render() {
    let LoggedInView = null;
      if (this.props.userStore.IsLoggedIn()) {
        LoggedInView = 
          <Nav pullRight>
          <NavItem eventKey={5} >
           Welcome {this.props.userStore.CurrentUser.FirstName}
          </NavItem>
          <NavItem eventKey={6} onClick={()=>{ this.props.userStore.Logout(); }}>
            Logout
          </NavItem>
        </Nav>;
      }
    
    return (
      <Navbar collapseOnSelect>
      <Navbar.Header>
        <Navbar.Brand>
          <Link to="/"> BAPS</Link>
        </Navbar.Brand>
        <Navbar.Toggle />
      </Navbar.Header>
      <Navbar.Collapse>
        <Nav>
          <NavItem eventKey={1} componentClass={Link} to="/Rooms" href="/Rooms">
            Rooms
      </NavItem>
          <NavItem eventKey={2} componentClass={Link} to="/Policies" href="/Policies">
            Policies
      </NavItem>
          <NavItem eventKey={3} componentClass={Link} to="/Announcements" href="/Announcements">
            Announcements
      </NavItem>
        </Nav>
     {LoggedInView}
      </Navbar.Collapse>
    </Navbar>
    );
  }
}
export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js